import { PaletteMode } from '@mui/material';
import { GetThemeOptions } from '@/theme/theme';
import { chronoDefinedDarkTokens, chronoDefinedLightTokens } from '@/theme/unityTokens';
import { ChronosphereColorPalette, purple } from '../colors';

export const newColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? chronoDefinedLightTokens : chronoDefinedDarkTokens;
    return {
      main: tokens['--data-informative-new'],
      highContrast: tokens['--data-informative-new-high-contrast'],
      lowContrast: tokens['--data-informative-new-low-contrast'],
    };
  }

  return mode === 'light'
    ? {
        main: purple[500],
        highContrast: purple[700],
        lowContrast: purple[100],
      }
    : {
        main: purple[400],
        highContrast: purple[100],
        lowContrast: purple[800],
      };
};
